import { render, staticRenderFns } from "./CurriculumListNECStudentRow.vue?vue&type=template&id=a6bb5534&scoped=true&"
import script from "./CurriculumListNECStudentRow.vue?vue&type=script&lang=ts&"
export * from "./CurriculumListNECStudentRow.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumListNECStudentRow.vue?vue&type=style&index=0&id=a6bb5534&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bb5534",
  null
  
)

export default component.exports